import { render } from "./MyQuotes.vue?vue&type=template&id=ad1cc500&scoped=true"
import script from "./MyQuotes.vue?vue&type=script&lang=ts"
export * from "./MyQuotes.vue?vue&type=script&lang=ts"

import "./MyQuotes.vue?vue&type=style&index=0&id=ad1cc500&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ad1cc500"

export default script